import clsx from 'clsx';
import { useState } from 'react';
import { useSendFeedback } from '@/api';
import { Dialog } from './ui';

/** A two-field NPS: a score and, optionally, why. Asked after a stage or a month, never more often. */
export function FeedbackDialog({ projectId, context, open, onClose }: { projectId: string; context: string; open: boolean; onClose: () => void }) {
  const send = useSendFeedback();
  const [score, setScore] = useState<number>();
  const [comment, setComment] = useState('');
  const [done, setDone] = useState(false);

  return (
    <Dialog open={open} onClose={onClose} title={done ? 'Спасибо' : 'Как вам работа с нами?'}>
      {done ? (
        <div className="p-5 text-sm">
          <p>Оценку видит руководитель студии. Если что-то не так, он напишет вам сам.</p>
          <button className="btn-primary mt-5 w-full" onClick={onClose}>
            Готово
          </button>
        </div>
      ) : (
        <div className="space-y-4 p-5">
          <p className="text-sm text-muted">{context}. Насколько вероятно, что вы порекомендуете студию знакомым?</p>
          <div className="grid grid-cols-11 gap-1" role="radiogroup" aria-label="Оценка от 0 до 10">
            {Array.from({ length: 11 }, (_, i) => (
              <button
                key={i}
                role="radio"
                aria-checked={score === i}
                onClick={() => setScore(i)}
                className={clsx('num h-9 rounded text-sm transition-colors', score === i ? 'bg-ink text-inverse' : 'shadow-hair hover:bg-sunken')}
              >
                {i}
              </button>
            ))}
          </div>
          <div className="flex justify-between text-xs text-faint">
            <span>точно нет</span>
            <span>точно да</span>
          </div>
          <textarea className="field min-h-20" value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Что стоит улучшить? Необязательно" />
          <button className="btn-primary w-full" disabled={score === undefined || send.isPending} onClick={() => send.mutate({ projectId, score: score!, comment }, { onSuccess: () => setDone(true) })}>
            Отправить
          </button>
        </div>
      )}
    </Dialog>
  );
}
